export default __webpack_public_path__ + "static/sideprojects-e71975a9fb9cc280cc8405ea221f5d49.png";